import React from "react"
import { useRecoilState, useRecoilValue } from "recoil"
import {
  sizeState,
  themeState,
  listObjState,
  userObjState,
  pagesObjState,
} from "../recoil-atom"

import ListGroup from "./ListGroup"

const ListPage = ({ pageId }) => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [listObj, setListObj] = useRecoilState(listObjState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const [pagesObj, setPagesObj] = useRecoilState(pagesObjState)

  if (
    listObj[pageId].group0.length +
      listObj[pageId].group1.length +
      listObj[pageId].group2.length +
      listObj[pageId].group3.length <
    16
  ) {
    return <></>
  }

  const updatedAt = new Date(listObj[pageId].updatedAt)
  // const updatedAt = listObj[pageId].updatedAt
  const updatedAtYMDHM = `${(updatedAt.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${updatedAt
    .getDate()
    .toString()
    .padStart(2, "0")} ${updatedAt
    .getHours()
    .toString()
    .padStart(2, "0")}:${updatedAt.getMinutes().toString().padStart(2, "0")}`
  // console.log(pageId, updatedAtYMDHM)

  return (
    <>
      <div className="wrap-page">
        <div className="page">
          {listObj &&
            listObj[pageId].groupOrder.map((groupId, index) => (
              <>
                <ListGroup pageId={pageId} groupId={groupId} key={index} />
              </>
            ))}
          {listObj[pageId].userName && (
            <div className="marked-by">
              marked by&nbsp;
              <span className="author">{listObj[pageId].userName}</span>
              &nbsp;at&nbsp;
              <span className="author">{updatedAtYMDHM}</span>
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .wrap-page {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          /* width: ${size.pageWidth}px;
          margin: 10px auto 0 auto;
          border-radius: 20px;
          padding: 10px 0;
          background-color: ${userObj ? userObj.colors.b0 : theme.b0};
          box-shadow: 1px 1px 3px 1px ${userObj
            ? userObj.colors.b2
            : theme.b2}; */
        }
        .page {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          width: ${size.pageWidth}px;
          margin: 10px auto 0 auto;
          border-radius: 20px;
          padding: 10px 0;
          background-color: ${userObj ? userObj.colors.b0 : theme.b0};
          box-shadow: 1px 1px 3px 1px ${userObj ? userObj.colors.b2 : theme.b2};
        }

        .marked-by {
          margin-top: 10px;
          font-size: 12px;
          color: ${userObj ? userObj.colors.b2 : theme.b2};
          text-align: center;
        }
        .author {
          border-radius: 5px;
          padding: 0 8px;
          background-color: ${userObj ? userObj.colors.b1 : theme.b1};
          color: ${userObj ? userObj.colors.f2 : theme.f2};
        }
      `}</style>
    </>
  )
}

export default ListPage
